<svelte:options accessors/>
<script lang="ts">
    import NauiTable from "../../naui/components/NauiTable.svelte";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import DocumentTable from "../common/DocumentTable.svelte";

    export let poliza = {};
    export let historico = [];
    export let documentos = [];

    let columns = [
        {
            slug: 'fecha',
            label: 'Fecha',
            type: 'date',
            order: true
        },
        {
            slug: 'hora',
            label: 'Hora',
            type: 'date',
            order: true
        },
        {
            slug: 'estado',
            label: 'Estado',
            type: 'state',
            order: true
        },
        {
            slug: 'nota',
            label: 'Nota',
            type: 'text',
            order: true
        },
        {
            slug: 'realiza',
            label: 'Realizado por',
            type: 'text',
            order: true
        }
    ]


</script>
<section>
    <fieldset>
        <legend>Información de la póliza</legend>
        <table class="simple-table">
            <tr>
                <td style="min-width: 200px">Tomador</td>
                <td><strong>{poliza['tomador']}</strong></td>
            </tr>
            <tr>
                <td>Tipo de póliza</td>
                <td><strong>{poliza['tipo']}</strong></td>
            </tr>
            <tr>
                <td>No. Póliza</td>
                <td><strong>{poliza['numero']}</strong></td>
            </tr>
            <tr>
                <td>Bien asegurado</td>
                <td><strong>{poliza['bienAsegurado']}</strong></td>
            </tr>
            <tr>
                <td>No Radicado</td>
                <td><strong>{poliza['radicado']}</strong></td>
            </tr>
            <tr>
                <td>Fecha evento</td>
                <td><strong>{poliza['fechaEvento']}</strong></td>
            </tr>
        </table>
    </fieldset>
    <fieldset class="mb-3">
        <legend>Histórico del radicado</legend>
        <NauiTable {columns} data="{historico}"/>
    </fieldset>
    <fieldset>
        <legend>Adjuntar documento</legend>
        <DocumentTable data="" archivoLabel="DocumentoAdjunto" documentoLabel="Observaciones / Comentarios" checkbox="{false}" />
        <NauiButton caption="AÑADIR DOCUMENTO" size="small" color="accent" className="mt-1"/>
    </fieldset>
    <div class="py-15">
            <NauiButton caption="Enviar" color="accent" mode="solid" className="min-w-200px"/>
        </div>
</section>
